const catalogComponentLoaders = Object.freeze({
  'catalog.service-policy-workspace': async () => {
    const module = await import('./service-policy-workspace-component.js');
    return module.ServicePolicyWorkspaceComponent;
  },
});

export default catalogComponentLoaders;
